import React from 'react';
import { Pricing } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useTranslation, useEnvironment } from '@wix/yoshi-flow-editor';
import { NO_BREAK_SPACE } from '../../../../../constants';
import { getPeriodLabel } from '../../../../../utils';
import { st, classes } from './Recurrence.st.css';

export interface RecurrenceProps {
  pricing?: Pricing;
  recurringPlansExist: boolean;
  highlighted: boolean;
}

export const Recurrence: React.FC<RecurrenceProps> = ({ pricing, recurringPlansExist, highlighted }) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();

  return recurringPlansExist ? (
    <span data-hook={VIEWER_HOOKS.PLAN_RECURRENCE} className={st(classes.frequency, { highlighted, mobile: isMobile })}>
      {pricing?.subscription ? getPeriodLabel(pricing?.subscription, t) : NO_BREAK_SPACE}
    </span>
  ) : null;
};
